// userAgentManagment

export interface UserAgent {

  browserName     : string ,
  browserVersion  : string ,
  browserMajor    : string ,
  browserType     : string ,
  engineName      : string ,
  engineVersion   : string ,
  osName          : string ,
  osVersion       : string ,
  deviceType      : string ,
  deviceVendor    : string ,
  deviceModel     : string ,
  cpuArchitecture : string
}

export const initializedUserAgent = (): UserAgent => ( 
 {
  browserName     : "" ,
  browserVersion  : "" ,
  browserMajor    : "" ,
  browserType     : "" ,
  engineName      : "" ,
  engineVersion   : "" ,
  osName          : "" ,
  osVersion       : "" ,
  deviceType      : "" ,
  deviceVendor    : "" ,
  deviceModel     : "" ,
  cpuArchitecture : ""
});
